import * as React from "react";
import { Input, Icon, Button, Form } from "antd";
import Text from "antd/lib/typography/Text";
import whiteLogo from "../../assets/images/headerlogo.png";
import { IRouter } from "../../../runtime/Router";

const PasswordResetForm = ({
  translate,
  buttonDisabled,
  resetPassword,
  onChangeUsername,
  loading,
  title,
  router
}: {
  translate: any;
  username?: string;
  buttonDisabled?: boolean;
  resetPassword: any;
  onChangeUsername: any;
  loading: boolean;
  title: string;
  router: IRouter;
}) => {
  return (
    <div className="login-container">
      <div className="login-header-container">
        <div>
          <img className="logo-container" src={whiteLogo} alt="Logo" />
        </div>

        <div className="login-subheader-container">
          <Text className="login-title">{translate(`app.${title}`)}</Text>
          <Text className="login-subtitle">{translate("app.name")}</Text>
        </div>
      </div>
      <div className="login-form-container">
        <div className="login-title-wrapper">
          <Text className="login-text ">
            {translate("reset_password.title")}
          </Text>
        </div>

        <div className="login-form-item-container">
          <div style={{ alignSelf: "start" }}>
            <Text>{translate("reset_password.hint")}</Text>
          </div>
          <Input
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder={translate("login.username")}
            onChange={(e) => onChangeUsername(e.target.value)}
            allowClear={true}
            style={{ marginTop: 35, marginLeft: 50, marginRight: 50 }}
          />

          <Button
            type="primary"
            disabled={buttonDisabled}
            onClick={resetPassword}
            className="login-button"
            loading={loading}
          >
            {translate("reset_password.reset")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordResetForm;
